// src/shadowGrove/world/genius.js

export const LIBERI_GENIUS = {
    defaultName: "Blueberry",

    species: "Genius",

    inspiration: {
        nature: "forest-born",
        mythology: "Faunus-inspired",
        form: "cat-faun companion",
    },

    meaning:
        "The Genius is the visible spark of the scholar's inner curiosity, wisdom, and perseverance.",

    growth:
        "As the scholar learns, practices, wonders, and perseveres, the Genius grows stronger.",

    stages: [
        {
            id: "spark",
            name: "First Spark",
            description:
                "A small glowing presence discovered in the moonlit forest.",
        },
        {
            id: "companion",
            name: "Forest Companion",
            description:
                "The spark takes shape and begins guiding the scholar toward the Academy.",
        },
        {
            id: "awakened",
            name: "Awakened Genius",
            description:
                "The Genius becomes stronger as the scholar grows in knowledge and confidence.",
        },
    ],
};